import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';
import { SelectOptionProps } from '../../SelectOption.types';

type Props = Pick<SelectOptionProps, 'error' | 'menuPlacement' | 'menuIsOpen'>;

export const useStyles = ({ menuPlacement, error }: Props) => {
  const styles = useStyleSheet(
    (theme) => {
      const getBoxShadow = () => {
        if (menuPlacement === 'top') {
          return `rgba(0,0,0, 0.1) 0px -4px 4px`;
        }

        return `rgba(0,0,0, 0.1) 0px 4px 4px`;
      };
      return {
        root: {
          top: menuPlacement === 'bottom' ? `calc(100% - ${error ? '24' : '10'}px)` : 'initial',
          bottom: menuPlacement === 'bottom' ? 'initial' : 'calc(100% - 22px)',
          backgroundColor: theme.palette.common.white,
          boxShadow: getBoxShadow(),
          borderRadius: theme.borderRadius.sm,
          margin: 0,
          display: 'flex',
          flexDirection: menuPlacement === 'bottom' ? 'column' : 'column-reverse',
          gap: theme.spacing.secondary,
          position: 'absolute',
          zIndex: 100,
          border: 'none',
        },
        dividerContainer: {
          paddingLeft: theme.spacing.secondary,
          paddingRight: theme.spacing.secondary,
          paddingTop: menuPlacement === 'bottom' ? theme.spacing.secondary : 0,
          paddingBottom: menuPlacement === 'bottom' ? 0 : theme.spacing.secondary,
          marginBottom: menuPlacement === 'top' ? '1rem' : 0,
        },
        footerContainer: {
          ...(menuPlacement === 'bottom'
            ? { borderTop: theme.dividers.main }
            : { borderBottom: theme.dividers.main }),
          margin: `0 ${theme.spacing.secondary}`,
          padding: '10px 0',
        },
      };
    },
    [menuPlacement, error],
  );

  return styles;
};
